export default function getEnv(name: any) {
  return window?.configs?.[name] || process.env[name]
}
